import type { PaginatedResponse } from '@/shared/api/types/api-response'

export function getNextPaginatedPageParam<T>(
  lastPage: PaginatedResponse<T>,
  allPages: PaginatedResponse<T>[],
) {
  const loadedCount = allPages.reduce((count, page) => count + page.data.length, 0)
  if (lastPage.data.length < lastPage.pageSize || loadedCount >= lastPage.total) {
    return undefined
  }
  return lastPage.current + 1
}
